export default __webpack_public_path__ + "static/media/tapicerowane2.9c640fe2.jpg";